import { useTranslations } from 'next-intl';

import { Spinner } from '@flipster/react/design-system/spinner';
import { CountdownDate } from '@flipster/react/design-utils/countdown-date';
import CheckIcon from '@flipster/react/icon/generated/CheckIcon';
import { Styles, css } from '@flipster/styled-system/css';
import { center, hstack } from '@flipster/styled-system/patterns';

interface Props {
  expiresAt?: string;
  forceResendLabel?: boolean;
  onClick?: () => void;
  loading?: boolean;
  verified?: boolean;
  disabled?: boolean;
  css?: Styles;
}

export const OtpVerifyButton = ({
  expiresAt,
  forceResendLabel = false,
  onClick,
  loading,
  verified,
  disabled = false,
  css: cssProps,
}: Props) => {
  const t = useTranslations();

  if (verified)
    return (
      <div className={hstack({ gap: 4, flexShrink: 0, color: 'content.accent.info', ...cssProps })}>
        <CheckIcon size={16} />
        <p className={css({ textStyle: 'Text/S/Strong' })}>{t('Common.r250710.Verified')}</p>
      </div>
    );

  return (
    <div className={hstack({ gap: 4, flexShrink: 0, ...cssProps })}>
      {!disabled && expiresAt && (
        <CountdownDate
          targetDate={expiresAt}
          format='${mm}:${ss}'
          css={{ textStyle: 'Text/S/Monospace/Strong', color: 'content.default.level-3' }}
        />
      )}
      <div className={center({ pos: 'relative', ...(loading && { minH: 30, minW: 30 }) })}>
        {loading ? (
          <Spinner size={24} color='gray' />
        ) : (
          onClick && (
            <button type='button' className={buttonStyle} onClick={onClick} disabled={disabled || loading}>
              {expiresAt || forceResendLabel ? t('Common.r250710.Resend') : t('Common.r250710.Get_code')}
            </button>
          )
        )}
      </div>
    </div>
  );
};

const buttonStyle = css({
  textStyle: 'Text/S/Strong',
  color: 'content.accent.info',
  flexShrink: 0,
  _hover: {
    color: 'content.accent.info.hover',
  },
  _disabled: {
    color: 'content.interactive.disabled',
  },
});
